module.exports = __webpack_public_path__ + "media/assets/icons/icon_envelope-aefee19682db561b89fae98ea2502ae2.svg";